import { render, staticRenderFns } from "./bindExamDialog.vue?vue&type=template&id=ffcc5d38"
import script from "./bindExamDialog.vue?vue&type=script&lang=js"
export * from "./bindExamDialog.vue?vue&type=script&lang=js"
import style0 from "./bindExamDialog.vue?vue&type=style&index=0&id=ffcc5d38&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports